export const mapPrimaryIdToPath = (id: string): string => {
  return `/${id}`;
};

export const mapLabelToPath = (
  sectionId: string,
  label: string
): string | null => {
  if (sectionId === "topics") {
    if (label === "Xét duyệt thuyết minh") return "/topics/approval";
    if (label === "Đề tài đang triển khai") return "/topics/ongoing";
    if (label === "Đề tài hoàn thành") return "/topics/completed";
    if (label === "Đề tài không hoàn thành") return "/topics/incomplete";
  }
  if (sectionId === "cooperation") {
    if (label === "Tổ chức hợp tác") return "/cooperation/organizations";
    if (label === "Đoàn vào") return "/cooperation/inbound";
    if (label === "Đoàn ra") return "/cooperation/outbound";
    if (label === "Cán bộ nước ngoài") return "/cooperation/foreign-staff";
    if (label === "Hội nghị, hội thảo") return "/cooperation/conferences";
  }
  if (sectionId === "documents") {
    if (label === "Danh sách văn bản") return "/documents/incoming-list";
    if (label === "Văn bản pháp quy") return "/documents/regulations";
    if (label === "Nhóm nhận văn bản") return "/documents/groups";
  }
  if (sectionId === "research") {
    if (label === "Bài báo - Công trình khoa học") return "/articles";
    if (label === "Sáng kiến kinh nghiệm") return "/initiatives";
    if (label === "Sản phẩm sở hữu trí tuệ") return "/intellectual";
    if (label === "Hợp đồng - dịch vụ KH&CN") return "/contracts";
  }
  if (sectionId === "council") {
    if (label === "Danh sách Hội đồng") return "/councils";
    if (label === "Danh sách chuyên gia") return "/experts";
  }
  if (sectionId === "organization") {
    if (label === "Lý lịch khoa học") return "/scientific-cv";
    if (label === "Tổng hợp nhân sự theo trình độ của cán bộ")
      return "/personnel-summary";
    if (label === "Tổng hợp nhân sự theo chức danh nghiên cứu")
      return "/research-position-summary";
  }
  if (sectionId === "standards") {
    if (label === "Quản lý tiêu chuẩn") return "/standards";
  }
  if (sectionId === "equipment") {
    if (label === "Quản lý trang thiết bị") return "/equipment";
  }
  if (sectionId === "awards") {
    if (label === "Khen thưởng") return "/awards";
  }
  if (sectionId === "members") {
    if (label === "Danh sách thành viên") return "/members";
    if (label === "Xem với tư cách khoa") return "/members/as-faculty";
  }
  if (sectionId === "statistics") {
    if (label === "Thống kê tổng quan") return "/statistics/overview";
    if (label === "Tình hình sử dụng Kinh phí") return "/statistics/budget";
    if (label === "Báo cáo tiến độ đề tài NCKH") return "/statistics/progress";
    if (label === "Tiến độ thực hiện đề tài")
      return "/statistics/implementation";
    if (label === "Thống kê Đề tài, nhiệm vụ KHCN")
      return "/statistics/projects";
  }
  return null;
};

export const mapChildLabelToPath = (
  sectionId: string,
  parentId: string,
  childLabel: string
): string | null => {
  if (sectionId === "documents") {
    if (parentId === "incoming") {
      if (childLabel === "Văn bản đến chưa xử lý")
        return "/documents/incoming-unprocessed";
      if (childLabel === "Văn bản đến được giao")
        return "/documents/incoming-assigned";
      if (childLabel === "Văn bản đến giao đọc")
        return "/documents/incoming-reading";
    }
    if (parentId === "outgoing") {
      if (childLabel === "Văn bản đi chưa xử lý")
        return "/documents/outgoing/pending";
      if (childLabel === "Văn bản đi được giao")
        return "/documents/outgoing/assigned";
      if (childLabel === "Văn bản đi giao đọc")
        return "/documents/outgoing/reading";
    }
  }
  return null;
};
